@import 'styles/mixins';
@import 'styles/variables';

.floatingDropdown {
  top: 0;
  left: 0;
  z-index: 1;
  position: fixed;
}
